import { mapListToRecords, normalizeList, websocketsHandlerFactory } from '@sophocles/entities/entityUtils';
import { KoreSubscription, koreSubscriptionSchema } from '@sophocles/entities/KoreSubscription/record';
import { radioSchema, receiveRadios } from '@sophocles/entities/Radio';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

export const RECEIVE_KORE_SUBSCRIPTIONS = 'RECEIVE_KORE_SUBSCRIPTIONS';

function receiveKoreSubscriptions(data) {
  return {
    type: RECEIVE_KORE_SUBSCRIPTIONS,
    subscriptions: mapListToRecords(data, KoreSubscription),
  };
}

export const REQUEST_KORE_SUBSCRIPTION = 'REQUEST_KORE_SUBSCRIPTION';

function requestKoreSubscription(iccid) {
  return {
    type: REQUEST_KORE_SUBSCRIPTION,
    iccid,
  };
}

export function postKoreProvision(iccid, action) {
  return dispatch => {
    return apiClient
      .post('/kore/provision', {
        actions: [
          {
            iccid,
            action,
          },
        ],
      })
      .then(checkHttpStatus)
      .then(response => {
        return { success: true, data: response.data };
      })
      .catch(error => {
        dispatch(genericErrorAction(error, REQUEST_KORE_SUBSCRIPTION));
        const errorMessage = error.errors?.error || error.errors?.detail || 'Failed to perform action';
        return { success: false, error: errorMessage };
      });
  };
}

export function fetchKoreSync(iccid) {
  return dispatch => {
    return apiClient
      .get(`/kore/sync/${iccid}`)
      .then(checkHttpStatus)
      .then(response => {
        return { success: true, data: response.data };
      })
      .catch(error => {
        dispatch(genericErrorAction(error, 'KORE_SYNC'));
        // Return error info for inline display
        const errorMessage = error.errors?.error || error.errors?.detail || 'Failed to sync with Kore';
        return { success: false, error: errorMessage };
      });
  };
}

export function fetchKoreSubscriptionByICCID(iccid) {
  return dispatch => {
    dispatch(requestKoreSubscription(iccid));
    return apiClient
      .get('/kore/subscription', { params: { iccid } })
      .then(checkHttpStatus)
      .then(response => {
        return normalize(response.data, koreSubscriptionSchema);
      })
      .then(json => {
        return dispatch(receiveKoreSubscriptions(json.entities.koreSubscriptions));
      })
      .catch(error => dispatch(genericErrorAction(error, REQUEST_KORE_SUBSCRIPTION)));
  };
}

const activationReceiver = (dispatch, json) => {
  const keys = Object.keys(json.entities.radios);
  const radio = keys.length > 0 ? json.entities.radios[keys[0]] : null;
  if (radio == null) {
    return;
  }

  dispatch(receiveRadios(json.entities.radios));

  const koreJson = normalize(
    {
      iccid: radio.iccid ?? null,
      ip_address: radio.ip_address ?? null,
      state: 'Active',
    },
    koreSubscriptionSchema,
  );

  dispatch(receiveKoreSubscriptions(koreJson.entities.koreSubscriptions));
};

export const handleKoreActivationSocket = websocketsHandlerFactory(
  activationReceiver,
  () => console.log('cannot'),
  radioSchema,
);
